import { useMemo } from "react";

type Props = {
    latitude: number;
    longitude: number;
    width?: number;
    height?: number;
};

export const useStreetViewImage = (props: Props) => {
    const { latitude, longitude, width = 280, height = 200 } = props;

    const environment = process.env.REACT_APP_ENVIRONMENT || "development";

    return useMemo(() => {
        if (environment === "development") {
            return {
                url: null,
                width,
                height,
            };
        }

        const baseUrl = `https://maps.googleapis.com/maps/api/streetview?size=${width}x${height}`;
        const params = new URLSearchParams({
            location: `${latitude},${longitude}`,
            heading: "185",
            fov: "150",
            key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
        });

        return {
            url: `${baseUrl}&${params.toString()}`,
            width,
            height,
        };
    }, [environment, latitude, longitude, width, height]);
};
